import moment from "moment";
import { tr } from "@/i18n";

const getDefaultCouponDateRange = () => ({
  c_date_start: moment().startOf("day").format("YYYY-MM-DD HH:mm"),
  c_date_end: moment().endOf("day").format("YYYY-MM-DD HH:mm"),
});

const getCouponsDefaultState = () => {
  return {
    status: true,
    coupons: "",
    originalCoupons: null, // Store original coupons data
    isSearching: false, // Track if we're in search mode
    dataCagir: false,
    newScreenStatus: true,
    current: {
      c_hash: "",
      c_type: 0, // 0: Percentage discount, 1: Money discount, 2: discount for second item, 3: discount on the second item but not more than max_discount_amount
      p_type: 0, // 0: for all products, 1: for a specific product
      s_type: 0, // 0: for all services, 1: for delivery, 2: for pickup
      c_name: "",
      c_desc: "",
      c_phash: [],
      c_discount: 0,
      c_adminnotes: "",
      ...getDefaultCouponDateRange(),
      c_dates: [],
      c_stores: [],
      c_codes: [],
      c_code: "",
      c_use_type: 0,
      c_min_price: 0.0,
      l_type_online: 0,
      l_type_pos: 0,
      l_type_kiosk: 0,
      l_type_mobil: 0,
      c_max_discount: 0,
      c_cur_phash: [],
    },
    formValidation: {
      vCouponName: { isValid: false, errorMessage: "" },
      vCouponDiscount: { isValid: false, errorMessage: "" },
      vCouponPlatform: { isValid: false, errorMessage: "" },
      vCouponDate: { isValid: false, errorMessage: "" },
      vCouponStore: { isValid: false, errorMessage: "" },
      vCouponCode: { isValid: false, errorMessage: "" },
    },
  };
};

const coupons = {
  state: getCouponsDefaultState(),
  mutations: {
    RESET_FORM_COUPONS(state) {
      Object.assign(state.current, getCouponsDefaultState().current);
      Object.assign(
        state.formValidation,
        getCouponsDefaultState().formValidation
      );
    },
    GET_COUPON(state, payload) {
      state.current = {
        c_hash: payload.detail.chash,
        c_type: payload.detail.c_type,
        p_type: payload.detail.p_type,
        s_type: payload.detail.s_type,
        c_name: payload.detail.name,
        c_desc: payload.detail.message,
        c_phash: payload.detail.product_name,
        c_discount: payload.detail.discount,
        c_adminnotes: payload.detail.admin_notes,
        c_date_start: payload.dates[0].date_start,
        c_date_end: payload.dates[payload.dates.length - 1].date_end,
        c_dates: payload.dates,
        c_stores: payload.stores.map((store) => store.shash),
        c_codes: [],
        c_code: payload.detail.code,
        c_use_type: payload.detail.c_use_type,
        c_min_price: payload.detail.min_price,
        l_type_online: payload.detail.l_type_online,
        l_type_pos: payload.detail.l_type_pos,
        l_type_kiosk: payload.detail.l_type_kiosk,
        l_type_mobil: payload.detail.l_type_mobil,
        c_max_discount: payload.detail.max_discount_amount,
      };
    },
    GET_COUPONS(state, payload) {
      Object.assign(state, payload);
    },
    DELETE_COUPON(state, hash) {
      state.coupons.map((item, idx) => {
        if (item.detail.chash == hash) {
          // delete this coupons
          state.coupons.splice(idx, 1);
        }
      });
    },
    STORE_ORIGINAL_COUPONS(state, coupons) {
      state.originalCoupons = JSON.parse(JSON.stringify(coupons));
    },
    SET_SEARCH_RESULTS(state, searchResults) {
      state.isSearching = true;
      state.coupons = searchResults;
    },
    RESTORE_ORIGINAL_COUPONS(state) {
      if (state.originalCoupons) {
        state.coupons = state.originalCoupons;
        state.isSearching = false;
      }
    },
    ADD_COUPON(state, coupon) {
      if (Array.isArray(state.coupons)) {
        state.coupons.unshift(coupon);
      }
    },
    SET_COUPON_PRODUCTS(state, products) {
      state.current.c_cur_phash = products;
    },
  },
  actions: {
    closeCouponModalBox({ commit }) {
      commit("RESET_FORM_COUPONS");
      commit("RESET_MODALBOX");
    },
    async getCoupons({ commit }) {
      commit("LOADING", { isActiveStatus: true });
      try {
        let { data } = await window.$http.axios.get("coupons/getallitems");
        commit("GET_COUPONS", data);
      } catch (error) {
        console.error(error);
        return;
      }
      commit("LOADING", { isActiveStatus: false });
    },
    async saveCoupon({ state, commit, dispatch }) {
      commit("LOADING", { isActiveStatus: true });
      const params = new URLSearchParams();
      params.append("c_type", state.current.c_type);
      params.append("p_type", state.current.p_type);
      params.append("s_type", state.current.s_type);
      params.append("c_name", state.current.c_name);
      params.append("c_desc", state.current.c_desc);
      params.append("c_phash", JSON.stringify(state.current.c_phash));
      params.append("c_discount", state.current.c_discount);
      params.append("c_adminnotes", state.current.c_adminnotes);
      params.append("c_min_price", state.current.c_min_price);
      params.append("c_dates", JSON.stringify(state.current.c_dates));
      params.append("c_stores", JSON.stringify(state.current.c_stores));
      params.append("c_codes", JSON.stringify(state.current.c_codes));
      params.append(
        "l_type_online",
        JSON.stringify(state.current.l_type_online)
      );
      params.append("l_type_pos", JSON.stringify(state.current.l_type_pos));
      params.append("l_type_kiosk", JSON.stringify(state.current.l_type_kiosk));
      params.append("l_type_mobil", JSON.stringify(state.current.l_type_mobil));
      params.append("c_max_discount", state.current.c_max_discount);
      const config = {
        method: "post",
        url: "coupons/addcoupon",
        data: params,
      };
      try {
        let { data } = await window.$http.axios(config);
        if (data.status) {
          commit("ADD_COUPON", data.coupon);
          commit("NOTIFICATION_MESSAGE", {
            status: 1,
            title: "Saved",
            message: "Coupon has been saved successfully.",
          });
          dispatch("closeCouponModalBox");
        } else {
          commit("NOTIFICATION_MESSAGE", {
            status: -1,
            title: "Error",
            message: data.message,
          });
        }
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "Error",
          message: error.message,
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },
    async updateCoupon({ state, commit, dispatch }) {
      commit("LOADING", { isActiveStatus: true });
      const params = new URLSearchParams();
      // params.append("c_type", state.current.c_type);
      // params.append("p_type", state.current.p_type);
      params.append("c_hash", state.current.c_hash);
      params.append("s_type", state.current.s_type);
      params.append("c_name", state.current.c_name);
      params.append("c_desc", state.current.c_desc);
      params.append("c_phash", JSON.stringify(state.current.c_phash));
      params.append("c_discount", state.current.c_discount);
      params.append("c_adminnotes", state.current.c_adminnotes);
      params.append("c_min_price", state.current.c_min_price);
      params.append("c_dates", JSON.stringify(state.current.c_dates));
      params.append("c_stores", JSON.stringify(state.current.c_stores));
      // params.append("c_codes", JSON.stringify(state.current.c_codes));
      params.append("l_type_online", Number(state.current.l_type_online));
      params.append("l_type_pos", Number(state.current.l_type_pos));
      params.append("l_type_kiosk", Number(state.current.l_type_kiosk));
      params.append("l_type_mobil", Number(state.current.l_type_mobil));
      params.append("c_max_discount", state.current.c_max_discount);
      const config = {
        method: "post",
        url: "coupons/updatecoupon",
        data: params,
      };
      try {
        let { data } = await window.$http.axios(config);
        if (data.status) {
          commit("NOTIFICATION_MESSAGE", {
            status: 1,
            title: "Updated",
            message: "Coupon has been updated successfully.",
          });
          dispatch("closeCouponModalBox");
        } else {
          commit("NOTIFICATION_MESSAGE", {
            status: -1,
            title: "Error",
            message: data.message,
          });
        }
      } catch (error) {
        console.error(error);
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "Error",
          message: error.message,
        });
      } finally {
        commit("LOADING", { isActiveStatus: false });
      }
    },
    async deleteCoupon({ commit }, chash) {
      commit("LOADING", { isActiveStatus: true });
      try {
        const { data } = await window.$http.axios.get(`coupons/deleteitem?c=${chash}`);
        if (!data.status) {
          commit("NOTIFICATION_MESSAGE", {
            status: -1,
            title: "Error",
            message: data.message,
          });
          commit("LOADING", { isActiveStatus: false });
          return;
        }

        commit("DELETE_COUPON", chash);
        commit("NOTIFICATION_MESSAGE", {
          status: 1,
          title: "Deleted",
          message: "Coupon has been deleted successfully!",
        });
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "Error",
          message: error.message,
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },
    async getCouponProducts({ commit }, { shash, chash }) {
      commit("LOADING", { isActiveStatus: true });
      try {
        let response = await window.$http.axios.get(
          `coupons/getProducts?s=${shash}&c=${chash}`
        );
        if (response.data.status) {
          commit("SET_COUPON_PRODUCTS", response.data.coupons_products);
        } else {
          throw new Error(tr("Cannot get coupon product list."));
        }
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "Error",
          message: error.message,
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },
    async searchCoupons({ commit, state }, keyWords) {
      commit("LOADING", { isActiveStatus: true });
      try {
        let response = await window.$http.axios.get(
          `coupons/search?s=${keyWords}`
        );
        if (response.data.status) {
          // Store original coupons if not already stored
          if (!state.originalCoupons) {
            commit("STORE_ORIGINAL_COUPONS", state.coupons);
          }

          // Display search results (even if empty)
          commit("SET_SEARCH_RESULTS", response.data.coupons || []);
        } else {
          throw new Error(tr("Failed to search coupon."));
        }
      } catch (error) {
        commit("NOTIFICATION_MESSAGE", {
          status: -1,
          title: "Error",
          message: error.message,
        });
      }
      commit("LOADING", { isActiveStatus: false });
    },
    restoreOriginalCoupons({ commit }) {
      commit("RESTORE_ORIGINAL_COUPONS");
    },
  },
  getters: {
    getCouponState: (state) => {
      return state.status;
    },
  },
};

export default coupons;
